import React, { useState } from 'react'
import { useStyles } from './TextAreaStyle'
import InputLabel from '@material-ui/core/InputLabel'


export default function TextArea(props) {

  const { register, defaultValue } = props

  const classes = useStyles()
  const [filled, setfilled] = useState(defaultValue ? true : false)
  const [focused, setfocused] = useState(false)


  function onFocus(e) {
    setfocused(true)
    setfilled(e.target.value !== '')
  }

  function onBlur(e) {
    setfocused(false)
    setfilled(e.target.value !== '')
  }

  return (
    <div className={classes.textarea}>
      <div className={(focused) ? 'focused' : 'blured'}>
        <InputLabel className={(filled) ? 'filled' : 'empty'} >Commentaires</InputLabel>
        <textarea
          ref={register}
          name="commentaires"
          onFocus={onFocus}
          onBlur={onBlur}
          defaultValue={defaultValue}
        />
      </div>
    </div >

  )
}
